module.exports = __webpack_public_path__ + "img/hr-H-T-1-unload-connect-shadow.df7e26d8.png";